<template>
    <div class="h-swiper"
        @mouseover="changeInterval(true)" 
        @mouseleave="changeInterval(false)"
        :style="{'height': height}"
        :trigger="trigger"
    >
        <slot></slot>
        <!-- 左侧按钮 -->
        <div v-show="arrow=='always'?true:arrow=='never'?false:show" @click="clickIcon('left')"   :class="'h-icon h-icon-left h-icon-left--'+direction"> 
            <i class="el-icon-caret-left"></i>
        </div>
        <!-- 右侧按钮 -->
        <div v-show="arrow=='always'?true:arrow=='never'?false:show" @click="clickIcon('right')"  :class="'h-icon h-icon-right h-icon-right--'+direction">
            <i class="el-icon-caret-right"></i>
        </div>
        <!-- 控制圆点 -->
        <div 
         :class="'h-banner-circle h-banner-circle--'+ direction"
        >
            <ul>
                <li  
                    v-for="(item,index) in imgLength" 
                    :key="index"
                    :class="index === currentIndex? 'active': '' "
                    @click="changeImg(index)"
                    @mouseover="changeCircle(index)"
                ></li>
            </ul>
        </div>
    </div>
</template>

<script>
export default {
    name:"h-swiper",
    props:{
        // 是否自动播放
        autoplay:{
            type:Boolean,
            default:()=> true
        },
        // 自动切换的时间间隔
        interval:{
            type:Number,
            default:()=> 1000
        },
        // 轮播高度
        height:{
            type:String,
            default:()=>'200px'
        },
        // 轮播高度
        trigger:{
            type:String,
            default:()=>''
        },
        // 轮播反向
        direction:{
            type:String,
            default:()=>'horizontal'
        },
        // 箭头展示
        arrow:{
            type:String,
            default:()=>'hover'
        },
        // 轮播图类型
        type:{
            type:String,
            default:()=>''
        }
    },
    data() {
        return {
            currentIndex:0,
            show:false,
            timer:null,
            imgLength:null
        }
    },
    mounted(){
        this.$nextTick(()=>{
            this.imgLength = document.querySelectorAll('.h-swiper_item-content')
            this.startPlay()
            if(!this.autoplay){
                clearInterval(this.timer)
            }
        })
    },
    methods: {
        startPlay(){
            this.timer = setInterval(()=>{
                this.currentIndex ++ 
                if(this.currentIndex > this.imgLength.length-1){
                    this.currentIndex = 0
                }
                if(this.currentIndex < 0){
                    this.currentIndex = this.imgLength.length-1
                }
            },this.interval)
        },
        changeInterval(flag){
            this.show = flag
            if(flag){
                clearInterval(this.timer)
            }else{
                this.startPlay()
            }
        },
        clickIcon(type){
            switch (type) {
                case "left":
                    this.currentIndex --
                    this.currentIndex = this.currentIndex>=0?this.currentIndex:this.imgLength.length - 1
                    break;
                case "right":
                    this.currentIndex ++
                    this.currentIndex = this.currentIndex <= this.imgLength.length - 1?this.currentIndex:0
                    break;
            }
        },
        changeImg(index){
            this.currentIndex = index
        },
        changeCircle(index){
            if(this.trigger != 'click'){
                this.currentIndex = index
            }
        }
    },
    // 卸载后关闭
    beforeDestroy(){
        clearInterval(this.timer)
    },
    // watch:{
    //     currentIndex:{
    //         immediate:true,
    //         handler(newv){
    //             if(newv && this.imgLength){
    //                 this.imgLength[newv+1].classList.add('h-swiper_item--a')
    //                 this.imgLength[newv].classList.add('h-swiper_item--b') 
    //                 this.imgLength[newv-1].classList.add('h-swiper_item--c') 
    //             }
    //         }
    //     }
    // }
}
</script>

<style scoped lang="less">
.h-swiper{
    width: 100%;
    position: relative;
    .h-icon{
        position: absolute;
        width: 30px;
        height: 30px;
        border-radius: 50%;
        background-color: rgba(125,125,125,.5);
        line-height: 30px;
        text-align: center;
        font-size: 25px;
        color: #DCDFE6;
        cursor: pointer;
        &:hover{
            background-color: rgba(125,125,125,.8);
        }
        &.h-icon-left--horizontal{
            top: 50%;
            transform: translateY(-50%);
            left: 10px;
        }
        &.h-icon-right--horizontal{
            top: 50%;
            transform: translateY(-50%);
            right: 10px;
        }
        &.h-icon-left--vertical{
            top: 10px;
            right: 50%;
            transform: translateX(50%);
            transform: rotate(90deg);
        }
        &.h-icon-right--vertical{
            right: 50%;
            transform: translateX(50%);
            bottom: 10px;
            transform: rotate(90deg);
        }
    }
    .h-banner-circle{
        position: absolute;
        ul{
            list-style: none;
            display: flex;
            margin: 0;
            padding: 0;
            .active{
                background: #fff;
            }
            li{
                background: #C0C4CC;
                cursor: pointer;
            }
        }
        &.h-banner-circle--horizontal{
            bottom: 10px;
            right: 50%;
            transform: translateX(50%);
            ul{
                li{
                    height: 3px;
                    width: 20px;
                    margin-right: 10px;
                }
            }
        }
        &.h-banner-circle--vertical{
            top: 50%;
            transform: translateY(-50%);
            right: 10px;
            ul{
                display: flex;
                flex-direction: column;
                margin: 0;
                padding: 0;
                li{
                    height: 20px;
                    width: 3px;
                    margin-top: 10px;
                }
            }
        }
    }
}

// 左侧进入
@keyframes fadein_left {
  0% {
    opacity: 0;
    transform: translateX(-10px);
  }

  100% {
    opacity: 1;
    transform: translateX(0px);
  }
}
// 右侧进入
@keyframes fadein_right {
  0% {
    opacity: 0;
    transform: translateX(0);
  }
  100% {
    opacity: 1;
    transform: translateX(-10px);
  }
}
// 顶部进入
@keyframes fadein_top {
  0% {
    transform: rotate(90deg);
    opacity: 0;
    transform: translateY(0);
  }
  100% {
    opacity: 1;
    transform: rotate(90deg);
    transform: translateY(5px);
  }
}
// 底部进入
@keyframes fadein_buttom {
  0% {
    opacity: 0;
    transform: translateY(0);
  }
  100% {
    opacity: 1;
    transform: translateY(-5px);
  }
}
.h-swiper_item--a{
    opacity: 1;
    z-index: 23;
    width: 100%;
    height: 100%;
    -webkit-transform: translateX(255px) translateZ(-300px) rotateY(-45deg);
    -ms-transform: translateX(255px) translateZ(-300px) rotateY(-45deg);
    transform: perspective(500px) translateX(300px) translateZ(-253px) rotateY(-45deg);
    -webkit-box-reflect: below 10px -webkit-gradient(linear, left top, left bottom, from(transparent), color-stop(30%, transparent), to(rgba(250, 250, 250, 0.3)));
}

.h-swiper_item--b {
    opacity: 1;
    z-index: 33;
    -webkit-box-reflect: below 10px -webkit-gradient(linear, left top, left bottom, from(transparent), color-stop(30%, transparent), to(rgba(250, 250, 250, 0.3)));
    transform: translateX(0) translateZ(-100px) rotateY(0deg)
}

.h-swiper_item--c {
    opacity: 1;
    z-index: 23;
    -webkit-box-reflect: below 10px -webkit-gradient(linear, left top, left bottom, from(transparent), color-stop(30%, transparent), to(rgba(250, 250, 250, 0.3)));
    -webkit-transform: translateX(255px) translateZ(-300px) rotateY(-45deg);
    -ms-transform: translateX(255px) translateZ(-300px) rotateY(-45deg);
    transform: perspective(500px) translateX(-300px) translateZ(-253px) rotateY(45deg);
}
</style>
